
// Blog frontpage JS
document.addEventListener("DOMContentLoaded", function () {
  const articleButtonLatest = document.querySelector('.post-box-article-types__latest');
  const articleButtonPopular = document.querySelector('.post-box-article-types__popular');

  const articleContainerLatest = document.querySelector('.post-box-latest-articles');
  const articleContainerPopular = document.querySelector('.post-box-popular-articles');

  if (articleButtonPopular) {
    articleButtonLatest.addEventListener('click', function () {
      articleButtonPopular.classList.remove('active');
      articleContainerPopular.classList.remove('active');
      this.classList.add('active');
      articleContainerLatest.classList.add('active');
    });

    articleButtonPopular.addEventListener('click', function () {
      articleContainerLatest.classList.remove('active');
      articleButtonLatest.classList.remove('active');
      this.classList.add('active');
      articleContainerPopular.classList.add('active');
    });
  }
});

// Category page JS
document.addEventListener("DOMContentLoaded", function () {
  let postOffset = 12;
  const postPerPage = 12;

  const loadMorePosts = document.getElementById('loadMorePosts');
  if (loadMorePosts) {
    loadMorePosts.addEventListener('click', function () {
      loadPosts();
    });
  }

  function loadPosts() {
    // Different language responses for js functions
    var checkLang = document.documentElement.lang;

    let noMoreContent;

    switch (checkLang) {
      case "fi":
        noMoreContent = 'Ei enää ladattavaa sisältöä';
        timeToRead = 'min lukuaika';
        break;
      case "en-US":
        noMoreContent = 'No more content to load';
        timeToRead = 'min read';
        break;
      case "sv-SE":
        noMoreContent = 'Inget mer innehåll att ladda';
        timeToRead = 'min lästid';
        break;
      default:
        noMoreContent = 'No more content to load';
        timeToRead = 'min read';
    }
    const loadingIcon = document.querySelector('.load-more-posts .loader');
    const loadMoreButton = document.querySelector('.load-more-posts button');
    const getCatId = loadMorePosts.dataset.itemsCategory;
    loadMoreButton.style.display = 'none';
    loadingIcon.style.display = 'block';
    const apiUrl = '/wp-json/wp/v2/posts?categories=' + getCatId + `&offset=${postOffset}&per_page=${postPerPage}`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const postContainer = document.querySelector('.post-container__post-grid');
        loadingIcon.style.display = 'none';
        loadMoreButton.style.display = 'flex';
        if (data.length > 0) {
          data.forEach(post => {

            const postCard = document.createElement('div');
            postCard.classList.add('single-post-card');

            const postCardHeader = document.createElement('div');
            postCardHeader.classList.add('single-post-card__header');
            postCard.appendChild(postCardHeader);

            const postImage = document.createElement('img');
            postImage.src = post.article_thumbnail;
            postImage.alt = post.title.rendered;
            postImage.classList.add('single-post-card__post-image');
            postCardHeader.appendChild(postImage);

            const postCardBody = document.createElement('div');
            postCardBody.classList.add('single-post-card__body');
            postCard.appendChild(postCardBody);

            const postCardPostInfo = document.createElement('div');
            postCardPostInfo.classList.add('single-post-card__post-info');
            postCardBody.appendChild(postCardPostInfo);

            const postCardPublishDate = document.createElement('p');
            postCardPublishDate.classList.add('single-post-card__publish-date');
            const getDate = post.date;
            const date = new Date(getDate);
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const formattedDate = `${day}.${month}.${year}`;
            postCardPublishDate.textContent = formattedDate;
            postCardPostInfo.appendChild(postCardPublishDate);

            const postCardTimeToRead = document.createElement('p');
            postCardTimeToRead.classList.add('single-post-card__time-to-read');
            postCardTimeToRead.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"></path></svg>' + post.custom_time_to_read + ' ' + timeToRead + '</span>'
            postCardPostInfo.appendChild(postCardTimeToRead);


            const postTitle = document.createElement('h2');
            postTitle.classList.add('single-post-card__title');
            postCardBody.appendChild(postTitle);

            const postlink = document.createElement('a');
            postlink.setAttribute('href', post.link);
            postlink.innerHTML = post.title.rendered;
            postTitle.appendChild(postlink);

            postContainer.appendChild(postCard);
          });
        } else {
          const replaceLoadMoreButton = document.querySelector('.load-more-posts');
          replaceLoadMoreButton.classList.remove('load-more-posts');
          replaceLoadMoreButton.innerHTML = '<p style="text-align: center; margin-top: 64px;">' + noMoreContent + '</p>'
        }
        postOffset += postPerPage;
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });
  }

});


// Article page JS 
// Remove old table of contents from article page
document.addEventListener("DOMContentLoaded", function () {
  const articlePage = document.querySelector('.article-content');
  if (articlePage) {
    const oldTableOfContents = articlePage.querySelectorAll('.table-of-contents-blog');
    oldTableOfContents.forEach(function (tableOfContent) {
      tableOfContent.remove();
    });
  }
});

// Create table of content to articles page automatically
document.addEventListener("DOMContentLoaded", function () {
  // Find all headings within the article-content div
  var articleContent = document.querySelector('.article-content');
  if (articleContent) {
    var headings = articleContent.querySelectorAll('h2');
    var list = document.createElement('ul');
    list.setAttribute('id', 'articleTableOfContents');
    var h2TitleItem;

    // Loop through each heading
    headings.forEach(function (heading, index) {
      var text = heading.textContent;
      var id = heading.id || 'heading-' + (index + 1); // Use existing ID or create a new one

      // Set the ID only if it doesn't already exist
      if (!heading.id) {
        heading.setAttribute('id', id);
      }

      // Create a list item with a link to the heading
      var anchor = document.createElement('a');
      anchor.setAttribute('href', '#' + id);
      anchor.textContent = text;
      var listItem = document.createElement('li');
      listItem.appendChild(anchor);

      // Check the level of the heading
      var level = parseInt(heading.nodeName.replace('H', ''));

      // If it's a top-level heading, add it to the list
      if (level === 2) {
        if (h2TitleItem) {
          list.appendChild(h2TitleItem);
        }
        h2TitleItem = listItem;
        secondLevelItem = null;
        thirdLevelItem = null;
      }
    });

    // Append any remaining items to the list
    if (h2TitleItem) {
      list.appendChild(h2TitleItem);
    }

    // Add the list to the page
    var contentList = document.querySelector('#articleTableOfContents');
    if (contentList) {
      contentList.parentNode.replaceChild(list, contentList);
    } else {
      // If the table of contents doesn't exist, add it to a suitable location
      articleContent.insertBefore(list, articleContent.firstChild);
    }
  }
});

/*   OLD CODE - removed from use 13.2.2025
// Create table of content to articles page automatically
   document.addEventListener("DOMContentLoaded", function() {
       // find all headings within the article-content div
       var articleContent = document.querySelector('.article-content');
       if (articleContent) {
       var headings = articleContent.querySelectorAll('h2');
       var list = document.createElement('ul');
       list.setAttribute('id', 'articleTableOfContents');
       var h2TitleItem;
     
       // loop through each heading
       headings.forEach(function(heading, index) {
         var text = heading.textContent;
         var id = 'heading-' + (index + 1);
     
         // add the ID to the heading
         heading.setAttribute('id', id);
     
         // create a list item with an anchor link to the heading
         var anchor = document.createElement('a');
         anchor.setAttribute('href', '#' + id);
         anchor.textContent = text;
         var listItem = document.createElement('li');
         listItem.appendChild(anchor);
     
         // check the level of the heading
         var level = parseInt(heading.nodeName.replace('H', ''));
     
         // if it's a top-level heading, add it to the list
         if (level === 2) {
           if (h2TitleItem) {
             list.appendChild(h2TitleItem);
           }
           h2TitleItem = listItem;
           secondLevelItem = null;
           thirdLevelItem = null;
         }
       });
     
       // append any remaining items to the list
       if (h2TitleItem) {
         list.appendChild(h2TitleItem);
       }
     
       // add the list to the page
       var contentList = document.querySelector('#articleTableOfContents');
       contentList.parentNode.replaceChild(list, contentList);
     }
     });  */

// If there is no h2 title on articles then remove table of content
function removeTableOfContents() {
  var contentList = document.querySelector('#articleTableOfContents');
  if (contentList && contentList.children.length === 0) {
    var sidebarTableOfContents = document.querySelector('.blog-articlepage__column-sidebar-left');
    var inPageTableOfContents = document.getElementById('inpageTableOfContents');

    var mainContentColumn = document.querySelector('.blog-articlepage__column-content');
    var rightSidebarColumn = document.querySelector('.blog-articlepage__column-sidebar-right');

    sidebarTableOfContents.remove();
    inPageTableOfContents.remove();

    if (mainContentColumn.classList.contains('grid-l-7') && rightSidebarColumn.classList.contains('grid-l-3')) {
      mainContentColumn.classList.remove('grid-l-7');
      mainContentColumn.classList.add('grid-l-8');
      rightSidebarColumn.classList.remove('grid-l-3');
      rightSidebarColumn.classList.add('grid-l-4');
    }
  }

}

setTimeout(removeTableOfContents, 50);



function handleResize() {
  var sourceElement = document.getElementById('tableOfContentsContainer');
  var targetElement = document.getElementById('inpageTableOfContents');

  if (window.innerWidth < 992) {
    // Kopioi sisältö kohde-elementtiin ja tyhjennä lähde-elementti
    if (sourceElement && targetElement && sourceElement.innerHTML) {
      targetElement.innerHTML = sourceElement.innerHTML;
      sourceElement.innerHTML = '';
    }
  } else {
    // Kopioi sisältö takaisin lähde-elementtiin ja tyhjennä kohde-elementti
    if (sourceElement && targetElement && targetElement.innerHTML) {
      sourceElement.innerHTML = targetElement.innerHTML;
      targetElement.innerHTML = '';
    }
  }
}

// Tarkista ikkunan koko sivun latautuessa
window.addEventListener('load', handleResize);

// Tarkista ikkunan koko aina kun sen kokoa muutetaan
window.addEventListener('resize', handleResize); 